var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2361 26.5364C24.9512 26.5364 25.5308 25.9568 25.5308 25.2417C25.5308 24.5267 24.9512 23.947 24.2361 23.947C23.5211 23.947 22.9414 24.5267 22.9414 25.2417C22.9414 25.9568 23.5211 26.5364 24.2361 26.5364Z",
    fill: "#0688FA",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.698 37.359C35.7647 34.8511 38.4836 30.3702 38.4836 25.2418C38.4836 17.3764 32.1072 11 24.2418 11C16.3764 11 10 17.3764 10 25.2418C10 30.3702 12.7189 34.8511 16.7856 37.359",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3105 31.8514C30.5284 30.4829 32.0121 28.0385 32.0121 25.2419C32.0121 20.9512 28.5345 17.4736 24.2438 17.4736C19.9532 17.4736 16.4756 20.9512 16.4756 25.2419C16.4756 28.0385 17.9593 30.4829 20.1772 31.8514",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallPackage);
export default __webpack_public_path__ + "static/media/install-package.408bb021548b7ade865b21c68d28970f.svg";
export { ForwardRef as ReactComponent };